<template>
  <div class="eventComp_mode_14 eventComp_mode_container" v-show="currThemeObj">
    <div class="tableScrollArea" ref="tableParentDom">
      <multiLevelFold_table
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :tableMode="tableMode"
        :parentWidthPx="parentWidthPx"
        :isScrollFlag="isScrollFlag"
        :variableColWidthVw="variableColWidthVw"
        :tableCellDefaultWidthVw="tableCellDefaultWidthVw"
        :defaultWidthVwNum="defaultWidthVwNum"
        :tableColumnData="tableColumnData"
        :tableData="tableData"
        :expandKey="expandKey"
        :isExpandAll="isExpandAll"
        @toParentEvent="toParentEventHandler"
        v-show="tableData && tableData.length > 0"
      ></multiLevelFold_table>
    </div>
  </div>
</template>

<script>
// 适用： 带展开行 赛艇 （双人 团体 的出场名单） || 艺术体操 （集体全能 的出场名单） || 花样滑冰 （冰上舞蹈自由舞）
import multiLevelFold_table from '@components/platfromBase/compreSportsMeet/table/multiLevelFold_table.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'eventComp_mode_14',
  components: {
    multiLevelFold_table,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    datas: {
      type: Object,
      default: () => ({}),
    },
    competitorType: {
      type: String,
      default: '', // A || D || T
    },
  },
  mixins: [cup_base_data_mixin],
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug('mode_14 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.init()
        }
      },
      //   immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      isScrollBottom: false,
      tableMode: 'eventComp_mode_14',
      parentWidthPx: 0,
      parentHeightPx: 0,
      isScrollFlag: false,
      isClickFlag: false,
      variableColWidthVw: null,
      tableCellDefaultWidthVw: 6.94, //默认列的宽度决定了展开行箭头占得宽度，因此这个最好不要动；如果需要处理某个单独列的宽度时，单独赋值
      expandCellDefaultWidthVw: 5.55,
      defaultWidthVwNum: null,
      tableColumnData: [],
      tableData: null,
      tableTotal: 0,
      expandKey: 'isExpand',
      isExpandAll: false, //只要需要expand属性默认都是展开，这个只是控制显示的高度
      currModeObj: null,
      renderModeList: [
        {
          modeNameArr: [],
          tableCellDefaultWidthVw: 11.1,
          sportsIdArr: ['ROW', 'RCB'],
          isCompetitorTypeArr: ['D', 'T'],
        },
        {
          modeNameArr: [],
          tableCellDefaultWidthVw: 8.33,
          sportsIdArr: ['GRY'],
          isCompetitorTypeArr: ['T'],
        },
        {
          modeNameArr: [],
          tableCellDefaultWidthVw: 11.1,
          sportsIdArr: ['FSK'],
          isCompetitorTypeArr: ['D'],
        },
      ],
    }
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.onResizeEvent()
    })
    this.init()
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  methods: {
    async init() {
      this.$nextTick(() => {
        this.onResizeEvent()
        // this.computedModeData({})
        if (this.currSportsDetail && this.currSportsDetail.sportsId) {
          this.renderModeList.forEach((modeItem) => {
            if (
              modeItem.sportsIdArr.includes(this.currSportsDetail.sportsId) &&
              modeItem.isCompetitorTypeArr.includes(this.competitorType)
            ) {
              this.currModeObj = modeItem
            }
          })
        }
        if (this.currModeObj) {
          this.computedModeData(JSON.parse(JSON.stringify(this.datas)))
        }
      })
    },
    toParentEventHandler(data) {
      console.debug(data)
      if (data && data.eventName === 'isTableAllExpandEvent') {
        this.tableData.forEach((rowData) => {
          rowData.isShowChild = data.data
        })
        this.isExpandAll = data.data
      }
      if (data && data.eventName === 'clickItemRowArrowEvent') {
        let isExpandAll = true
        // 有一个是关闭的，全部就是【关闭】状态
        this.tableData.forEach((rowData) => {
          if (!rowData.isShowChild) {
            isExpandAll = false
          }
        })
        this.isExpandAll = isExpandAll
      }
    },
    onResizeEvent() {
      if (this.$refs.tableParentDom) {
        this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      } else {
        console.debug('dom 不存在')
      }
    },
    computedModeData(data) {
      console.debug('mode_14 computedModeData:', data)
      if (data && data.data) {
        this.tableTotal = data ? data.length : 0
        const table_headArr = data.table_head

        // 表头
        const headColumns = []
        let deletColumnNum = 0
        table_headArr.forEach((colums, colIndex) => {
          if (colums && colums.map_key_arr.length > 0) {
            headColumns.push({
              colKey: colums.map_key_arr[0] ? colums.map_key_arr[0] : '',
              colTitle: colums.name ? colums.name : '',
            })
          }
        })
        deletColumnNum = 2
        headColumns.push({
          colKey: 'arrowIcon',
          colTitle: '',
        })
        headColumns.push({
          colKey: 'isExpand',
          colTitle: '',
        })

        let customColumn = {}
        let rowHeightVw = 2.778, //第一行 行高 (只有奖牌榜medalTally用到这个字段，其他视图展开行的打开隐藏不需要计算这个值，它们的高度都是用内容撑出的高度)
          childRowHeightVw = 6.94, //第一行的展开行，如果是表格的话，就是展示数据的那一行的行高（一般这个行数是不固定的）
          childRowHeightOtherVw = 0 //0.694是表格最下面的留白

        let childRowBaseHeightVw = 0 //第一行展开行的基础高度（固定的高度）
        if (
          this.currModeObj.isCompetitorTypeArr.includes('D') ||
          this.currModeObj.isCompetitorTypeArr.includes('T')
        ) {
          // 赛艇 双人 || 团体
          const otherColumns = headColumns
          if (this.tableColumnData.length == 0) {
            let tableColumnData = []
            deletColumnNum++
            customColumn = {
              prop: 'teamLogo-teamName', //fristColumnPropArr.join('-'),
              label: '国家/地区',
              // widthVw: this.currModeObj.variableColWidthVw[this.currModeObj.sportsIdArr.indexOf(this.currSportsDetail.sportsId)], //对应列的宽度，单位vw
              className: 'columnTeamLogoTeamNameClass', //单独定制的头部样式class
              // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
            }

            if (this.currModeObj.tableCellDefaultWidthVw) {
              this.tableCellDefaultWidthVw =
                this.currModeObj.tableCellDefaultWidthVw
            }
            let widthVw = this.tableCellDefaultWidthVw

            for (let i = 0; i < otherColumns.length; i++) {
              const item = otherColumns[i]
              if (['运动员', '姓名', '国家/地区'].includes(item.colTitle)) {
                // 特殊列
                tableColumnData.push(customColumn)
              } else {
                tableColumnData.push({
                  prop: item.colKey,
                  label: item.colTitle,
                  widthVw: ['arrowIcon', 'isExpand'].includes(item.colKey)
                    ? this.expandCellDefaultWidthVw / 2
                    : widthVw, //单独设置 [arrowIcon, isExpand] 的对应列的宽度，单位vw, 宽度为普通的一半
                  className: ['arrowIcon', 'isExpand'].includes(item.colKey)
                    ? 'expandTdClassName'
                    : '', //单独定制的头部样式class
                  selected: '',
                })
              }
            }
            this.defaultWidthVwNum = tableColumnData.length - deletColumnNum //减去这3列[teamLogo-teamName, arrowIcon, isExpand]
            this.tableColumnData = tableColumnData
            console.debug('tableColumnData:', tableColumnData)
          }
        }
        this.tableData = data.data
          ? data.data.map((rowData) => {
              let currDataListRowNum = 0 //展开行有多高，取决于(上下半场)data.length个数

              rowData.arrowIcon = ''
              if (this.isExpandAll) {
                //是否全部展开
                rowData.isShowChild = true
              } else {
                rowData.isShowChild = false
              }

              rowData.row_detail = rowData.row_detail ? rowData.row_detail : []
              if (rowData.row_detail && rowData.row_detail.length > 0) {
                rowData.isHasDetailData = true
              } else {
                rowData.isShowChild = false //就是全部展开，如果没有子内容，展开无用，所以变为false
                rowData.isHasDetailData = false
              }

              currDataListRowNum = Math.ceil(rowData.row_detail.length / 4) //每行4个运动员，8个运动员就是2行

              rowData.isExpand = {
                renderMode: this.currSportsDetail.sportsId,
                expandClassString: this.currModeObj.modeNameArr.join(' '),
                rowHeightVw,
                currHeightVw:
                  childRowBaseHeightVw +
                  currDataListRowNum * childRowHeightVw +
                  childRowHeightOtherVw,
                list: rowData.row_detail,
              }
              return rowData
            })
          : []
        // this.$refs.tableParentDom.scrollTo(0, 0)
        console.debug('this.tableData:', this.tableData)
      } else {
        console.debug('暂无数据')
        this.notDataHandler()
      }
    },
    notDataHandler() {
      this.tableTotal = 0
      this.tableData = []
    },
  },
}
</script>

<style lang="scss" scoped>
.eventComp_mode_container {
  padding: 1.388vw 0;
  .tableScrollArea {
    position: relative;
    width: 100%;
  }
}
</style>
